<template>
  <div style="width: 100%">
    <FormLabel class="control-label"> Gender: </FormLabel>
    <div class="gender__row">
      <FormLabel for="Male" class="gender__label">
        <input
          type="radio"
          id="Male"
          name="gender"
          value="Male"
          :model="isGender"
          @click="isGender = 'Male'"
          :checked="isGender == 'Male'"
        /><span>Male</span>
      </FormLabel>
      <FormLabel for="Female" class="gender__label">
        <input
          type="radio"
          id="Female"
          name="gender"
          value="Female"
          :model="isGender"
          @click="isGender = 'Female'"
          :checked="isGender == 'Female'"
        /><span>Female</span>
      </FormLabel>
      <ErrorLabel field="custom.isGender" customError="Please select a gender" />
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  onMounted,
  ref,
  watch,
  computed,
} from 'vue';
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { getValue, setValue } = usePaymentForm();
    const isGender = ref("Male");

    onMounted(() => {
      setValue("custom.isGender", "Male");
    });

    watch(isGender, () => {
      if (isGender.value) {
        setValue("custom.isGender", isGender.value);
      }
    });

    return {
      getValue,
      isGender,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
.gender__row {
  display: flex;
  align-items: center;
  gap: 12px;
  input[type="radio"] {
    display: none;
  }
  input[type="radio"] + span {
    z-index: 10;
    margin: 0 0px 10px 0;
    padding: 7px 20px;
    border-radius: 4px;
    position: relative;
    color: #ced4da;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.1);
    font-weight: bold;
    background-color: #ffffff;
    border: 2px solid #ced4da;
    cursor: pointer;
    transition: all 200ms ease;
    &:hover {
      background-color: #f8f8f8;
    }
  }
  input[type="radio"]:checked + span {
    color: #495057;
    background-color: #ced4da;
  }
}
.gender__label {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
